import React from "react";
import { Container } from "@mui/material";
import Header from "./Header";
import LogoDisplay from "./LogoDisplay";
import IntroSection from "./IntroSection";
import Testimonials from "./Testimonials"; // New import here
import Footer from "./Footer";
import GoogleSignUpButton from "./GoogleSignUpButton";
import { MainContainer, ContentContainer, SectionBox } from "./landingStyles";
import backgroundImage from "../Assets/13.png";
import FakePDF from "./FakePDF";
import wednesday_dialog from "../Assets/dialouge/wednesday.json";
import { useState } from "react";
import WaveformLottie from "./WaveformLottie";

function LandingPage() {
  // eslint-disable-next-line no-undef
  const [currentFakePDFDialog, setCurrentFakePDFDialog] =
    useState(wednesday_dialog);
  const [isPlaying, setIsPlaying] = useState(false);


  return (
    <MainContainer backgroundImage={backgroundImage} className="fade-in">
      <div className="fade-in" style={{marginBottom: "20px"}}>
        <Header />
      </div>

      {/* <Container maxWidth="md" component={ContentContainer}>
        <div className="fade-in">
          <SectionBox>
            <IntroSection />
            <GoogleSignUpButton />
          </SectionBox>
        </div>
      </Container> */}

      <div className="fade-in" style={{ padding: "0px" }}>
        <LogoDisplay />
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '5vh' }}>
        <WaveformLottie play={isPlaying} />
      </div>

      <div className="fade-in">
        <FakePDF dialoguesData={currentFakePDFDialog} onPlayChange={setIsPlaying}/>
      </div>

      <div className="fade-in">
        <Testimonials />
      </div>

      <div className="fade-in">
        <Footer />
      </div>
    </MainContainer>
  );
}

export default LandingPage;
